<template lang="html">
  <v-overlay :value="model.active" style="position: absolute">
    <v-dialog
      :value="model.active"
      width="400"
      persistent
      attach="#admin-areas-container"
      no-click-animation
      hide-overlay>
      <v-card v-if="selected">
        <div class="d-flex justify-space-between align-center pr-2">
          <v-card-title class="text-h6 font-weight-bold">
            <v-icon left> {{ isEditing ? 'mdi-pencil' : 'mdi-plus' }}</v-icon>
            {{ isEditing ? 'Edit' : 'Add' }} Area
          </v-card-title>
          <v-btn icon @click="closeDialog"><v-icon>fa-close</v-icon></v-btn>
        </div>
        <v-divider></v-divider>

        <v-card-text class="pt-5">
          <v-form v-model="model.valid">
            <v-text-field
              outlined
              dense
              :rules="[formRules.required]"
              clearable
              v-virtual-keyboard
              label="Area Name"
              placeholder="Enter Area Name..."
              append-outer-icon="mdi-crop"
              @click:append-outer="startCrop"
              v-model.trim="selected.name">
            </v-text-field>

            <v-textarea
              dense
              outlined
              v-model="selected.description"
              label="Description"
              placeholder="Enter Area Description...">
            </v-textarea>

            <v-row>
              <v-col>
                <v-text-field
                  outlined
                  dense
                  disabled
                  :value="bbox.min.x"
                  hide-details
                  label="Min Point X"
                  placeholder="Min Point X">
                </v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  outlined
                  dense
                  disabled
                  :value="bbox.min.y"
                  hide-details
                  label="Min Point Y"
                  placeholder="Min Point Y">
                </v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  outlined
                  dense
                  disabled
                  :value="bbox.min.z"
                  hide-details
                  label="Min Point Z"
                  placeholder="Min Point Z">
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  outlined
                  dense
                  disabled
                  :value="bbox.max.x"
                  hide-details
                  label="Max Point X"
                  placeholder="Max Point X">
                </v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  outlined
                  dense
                  disabled
                  :value="bbox.max.y"
                  hide-details
                  label="Max Point Y"
                  placeholder="Max Point Y">
                </v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  outlined
                  dense
                  disabled
                  :value="bbox.max.z"
                  hide-details
                  label="Max Point Z"
                  placeholder="Max Point Z">
                </v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="red" elevation="0" text @click="closeDialog" :disabled="model.loading">
            close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn elevation="0" :disabled="!model.hasChanges || model.loading" @click="discard">
            discard
          </v-btn>
          <v-btn
            color="primary"
            elevation="0"
            @click="saveChanges"
            :loading="model.loading"
            :disabled="!model.valid">
            {{ isEditing ? 'Save' : 'Create' }} Area
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-overlay>
</template>
<script>
  import formRules from '@Share/config/form-rules';
  import { ForgeArea } from '@/scripts/js/forgeModels';
  import { $isEqual } from '@Utils';
import { takeScreenshot } from '@/scripts/js/forgeService';
import { getDbIdBBox } from '@/utils/forgeUtils';
import { log } from '@/utils/debugLogger';
  export default {
    data() {
      return {
        model: {
          active: false,
          valid: false,
          hasChanges: false,
          loading: false,
        },
        selected: new ForgeArea(),
        isEditing: false,
        formRules,
      };
    },
    methods: {
      open(area) {
        if (area) {
          this.isEditing = true;
          this.selected = Object.assign(new ForgeArea(), area);
          this.selected.parseContent();
          this.cementSelected();
        } else {
          area = new ForgeArea();
          area.isExpanded = true;
          area.name = 'New Area';
          this.isEditing = false;
          this.selected = area;
          this.selectedCemented = {};
        }
        this.model.active = true;
      },
      reset() {
        this.model.active = false;
        this.selected = null;
        this.selectedCemented = null;
      },
      closeDialog() {
        if (this.model.hasChanges) {
          const answer = window.confirm('You have unsaved changes on this page! leave anyway?');
          if (answer) {
            this.reset();
            this.discard();
          }
        } else {
          this.reset();
        }
      },
      discard() {
        this.selected = structuredClone(this.selectedCemented);
        this.model.hasChanges = false;
      },
      cementSelected() {
        this.selectedCemented = structuredClone(this.selected);
        this.checkForChanges();
      },
      checkForChanges() {
        if (!this.model.active) return;

        this.model.hasChanges = !$isEqual(this.selected, this.selectedCemented);
      },
      saveChanges() {
        let bbox = this.cropExtension.cropBox;

        if (bbox) {
          this.selected.boundingBox = bbox;
        }

        this.model.loading = true;

        this.selected.facilityId = this.$route.params.id;

        this.viewer.navigation.fitBounds(true, bbox);
        
        setTimeout(() => {
          this.cropExtension?.updateBoxVisibility(false);
          takeScreenshot(this.viewer, (base64) => {
            let dispatch = this.isEditing ? 'AREAS/UPDATE_ENTRY' : 'AREAS/ADD_ENTRY';
  
            this.selected.thumbnailBase64 = base64;
    
            this.$store
              .dispatch(dispatch, this.selected)
              .then(() => {
                this.$store.dispatch('AREAS/GET_ENTRIES');
                this.$dialog.notify.success('Area saved successfully');
                this.cementSelected();
                this.closeDialog();
              })
              .catch((e) => {
                log('EditArea', 'Failed to save area', e);
                this.$dialog.notify.error('Failed to save area');
              })
              .finally(() => {
                this.model.loading = false;
              });
          });
        }, 100);
      },
      async startCrop() {
        if (!this.viewer) {
          this.adminAppContainer.open3dViewerIfNot();
          this.$dialog.notify.warning('Please wait, model still loading');
          return;
        }

        if (!this.cropExtension) {
          this.$dialog.notify.warning('Please wait, model still loading');
          return;
        }

        let selection = this.viewer.model.selector.getSelection();

        if (!this.isEditing && (!selection || selection.length == 0)) {
          this.$dialog.notify.warning('Please select an object first');
          return;
        }

        let defaultBox = await getDbIdBBox(selection[0], this.viewer);

        this.cropExtension.cropBox = this.isEditing
          ? this.selected.boundingBox
          : defaultBox;

        this.cropExtension.toggleCropbox(true);
      },
    },
    computed: {
      adminAppContainer() {
        return this.$store.state.adminAppContainer;
      },
      viewer() {
        return this.$store.state.viewer;
      },
      cropExtension() {
        return this.viewer?.getExtension('Cropping3DExtension');
      },
      bbox() {
        return this.cropExtension?.cropBox || this.selected.boundingBox;
      },
    },
    watch: {
      selected: {
        handler() {
          this.checkForChanges();
        },
        deep: true,
      },
      'model.active'(val) {
        if (!val) {
          this.cropExtension?.toggleCropbox(false);
        }
      },
    },
  };
</script>
<style lang="scss"></style>
